import { Modal, Grid, Box } from "@mui/material";
import { useTheme } from "../style/theme";

const CustomImportEmpty = ({
    open,
    onClose,
    isScrollable = false,
    isSmall = false,
    children,
    handleMapDetails
}) => {
    const { mode } = useTheme()
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: mode === "dark" ? "#141414" : "#edf0f4",
                    display: "flex",
                    flexDirection: "column",
                    height: "98%",
                }}
                className={`${isSmall ? "w-2/5" : "w-[98%]"
                    } rounded-lg border border-neutral-700`}
            >
                {/* Scrollable content */}
                <Box
                    className="flex-1 overflow-y-auto"
                    sx={{ paddingBottom: "90px" }} // leave room for fixed footer
                >
                    {children}
                </Box>

                {/* Sticky footer (always at bottom) */}
                <Box
                    sx={{
                        backgroundColor: mode === "dark" ? "#171717" : "#fff",
                        borderTop: "1px solid #ccc",
                    }}
                    className="w-full px-3 py-3"
                >
                    <div className="flex flex-row gap-3 justify-between items-center">
                        <button
                            className="border border-[#0088FF] text-[#0088FF] rounded-[4px] px-3 py-1 text-sm"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="bg-[#0088FF] text-white rounded-[4px] px-3 py-1 text-sm"
                            onClick={handleMapDetails}
                        >
                            Done
                        </button>
                    </div>
                </Box>
            </Box>
        </Modal>

    );
};

export default CustomImportEmpty;
